<template>
    <div class="rent--spaces" :class="{ isloading: isLoading }">
        <div class="rent--spaces-scroll">
            <div class="rent--spaces-bg">
                <div class="rent--spaces-list" :style="cssVars">
                    <template v-if="data && data.length > 0">
                        <template v-if="returnCenters">
                            <!-- Centres -->
                            <CentreCard v-for="space in data" v-bind:key="space.node.id" :space="space.node" :linkType="'routerLink'" :user="user"></CentreCard>
                        </template>
                        <template v-else>
                            <!-- Spaces -->
                            <SpaceCard v-for="space in data" v-bind:key="space.node.id" :space="space.node" :linkType="'routerLink'" :user="user"></SpaceCard>
                        </template>
                    </template>
                    <template v-else>
                        <div v-if="data && isLoading === false" class="rent--spaces-no-spaces">
                            No results match your query. Try selecting fewer filters.
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import CentreCard from "../../components/search/CentreCard"
    import SpaceCard from "../../components/search/SpaceCard"

    export default {
        name: 'MapSpaces',
        data: () => ({
            showQuickView: false,
            user: null
        }),
        props: ['data', 'returnCenters', 'columns', 'showCart', 'isLoading'],
        components: {
            CentreCard,
            SpaceCard
        },
        computed: {
            cssVars() {
                return {
                    '--columns': this.columns
                }
            }
        },
        mounted() {
            this.getUser()
        },
        created() {
        },
        methods: {
            async getUser() {
                var self = this
                const response = axios
                  .get('/api/searches/get_user')
                  .then(response => {
                      if (response.data.response == true) {
                        self.user = response.data
                      }
                  })
                  return response
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../scss/global/includes";

.rent--spaces {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    overflow: hidden;
    &.isloading {
        background: url('/assets/button_loader_disabled.svg');
        background-size: 30px;
        background-position: center center;
        background-repeat: no-repeat;
        .rent--spaces-list {
            opacity: 0;
        }
    }

    @include breakpoint(tablet-landscape) {
        background: $light-grey;
        border-radius: 4px 4px 0 0;
    }
}

.rent--spaces-scroll {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    padding: 16px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        display: none;
    }

    @include breakpoint(tablet-landscape) {
        padding: 24px 32px;
    }

}

.rent--spaces-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    grid-gap: 8px;
    background: #FFFFFF;
    transition: opacity 0.6s ease-in-out;
    opacity: 1;
    @include breakpoint(desktop) {
        grid-template-columns: repeat(2, 1fr);
    }
    @include breakpoint(tablet-landscape) {
        gap: 16px;
        grid-template-columns: repeat(1, 1fr);
        background: $light-grey;
    }
}

.rent--spaces-no-spaces {
    padding: 10px 15px;
    margin: 20px 0;
    font-size: 14px;
    border-radius: 10px;
    grid-column: 1/-1;
    box-shadow: 0px 0px 2px 0px $border-grey;
}

</style>
